module.exports = __webpack_public_path__ + "img/Bryan.ce8496fd.jpg";